import BackendRepositoryRemote from '../api/BackendRepositoryRemote';
import { BackendRepository } from '../api/interfaces/BackendRepository';
import { NoTopSlot, NoTopSlotRange } from '../interfaces/NoTopSlot';
import { sendAnalyticsEvent } from './Analytics';

export interface GetNoTopSlotsResult {
  noTopSlots: NoTopSlot[];
}

export default class NoTopSlotService {
  private repository: BackendRepository;

  constructor(repository?: BackendRepository) {
    this.repository = repository || new BackendRepositoryRemote();
  }

  public async getNoTopSlots(ticketHashId: string, workOrderId: string): Promise<GetNoTopSlotsResult> {
    let noTopSlots: NoTopSlot[] = [];

    try {
      noTopSlots = await this.repository.getNoTopSlots(ticketHashId, workOrderId);
    } catch {
      sendAnalyticsEvent('scheduling', 'get-no-slots-failed');
    }

    return {
      noTopSlots
    };
  }
}

export const getIsAllPeriodsSelected = (periods: NoTopSlotRange[]) => {
  return !periods.some((period) => period.selected === false);
};
